<template>
  <inspector-frame v-if="!role" :x="-210" :y="-150" :force="true">
    <div class="ModeSelector">
      <div class="item" @click="choice(5)">
        <h2>PLモード</h2>
        <p>プレイヤーのひとはこちらを選択してください。</p>
        <h3>できること</h3>
        <ul>
          <li>キャラクター作成・編集</li>
          <li>音源追加・変更</li>
          <li>画像配置変更</li>
        </ul>
      </div>
      <div class="item kp" @click="choice(10)">
        <h2>KP・GMモード</h2>
        <p>KP・GMのひとはこちらを選択してください。</p>
        <h3>できること</h3>
        <ul>
          <li>キャラクター作成・編集</li>
          <li>シーン作成・編集</li>
          <li>共有メモ作成・編集</li>
          <li>音源追加・変更</li>
          <li>画像配置変更</li>
          <li>つまり全部</li>
        </ul>
      </div>
      <p class="note">※ あとから「設定」メニューよりいつでも変更できます。</p>
    </div>
  </inspector-frame>
</template>

<script>
import inspectorFrame from "../frames/inspector";

export default {
  components: { "inspector-frame": inspectorFrame },
  computed: {
    role() {
      return this.$store.getters["local/role"];
    },
    roleName() {
      return this.$store.getters["local/roleName"];
    }
  },
  methods: {
    choice(value) {
      this.$store.commit("local/set", { key: "role", value });
      if (value < 10) {
        this.$store.commit("local/set", { key: "tableEdit", value: false });
      }
      const { roleName } = this;
      this.$store.dispatch(
        "messages/log",
        `${roleName}モードが選択されました。`
      );
    }
  }
};
</script>

<style scoped>
.ModeSelector {
  width: 420px;
  height: 300px;
  display: flex;
}
/* .body {
  display: flex;
} */
.item {
  padding: 30px 15px;
  flex: 1;
  background: rgba(0, 0, 0, 0.2);
  text-align: center;
  cursor: pointer;
}
.item + .item {
  border-left: 1px solid #222;
}
.item.kp {
  background: rgba(0, 0, 0, 0.3);
}
.item:hover {
  background: rgba(0, 0, 0, 0.4);
}
.item.kp:hover {
  background: rgba(0, 0, 0, 0.5);
}
.item p {
  color: #888;
  font-size: 10px;
}
h2 {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}
h3 {
  margin-top: 12px;
  font-weight: normal;
  color: #888;
  text-decoration: underline;
}
ul {
  margin-top: 4px;
}
li {
  margin-bottom: 2px;
  list-style: none;
  color: #888;
  font-size: 10px;
}
p.note {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  font-size: 12px;
  background: #222;
}
</style>
